import React from "react"

import { Tooltip } from "react-tooltip"

import * as style from "./TooltipWrapper.module.scss"

const TooltipWrapper = ({
  children, id, content, place = "right", hideTooltip = false,
}) => (
  <>
    <div
      className={style.tooltipContainer}
      data-tooltip-id={`tooltip-${id}`}
      data-tooltip-content={content}
    >
      {children}
    </div>
    {!hideTooltip
    && (
    <Tooltip
      className={style.tooltip}
      id={`tooltip-${id}`}
      place={place}
    />
    )}
  </>
)

export default TooltipWrapper
